import RouteView from '@/components/RouteView';
import BasicLayout from '@/components/BasicLayout';

/**
 * 动态路由，根据用户角色动态过滤路由
 * @type { *[] }
 */
export const DYNAMIC_ROUTES = [{
  path: '/',
  name: 'index',
  component: BasicLayout,
  meta: { title: '首页' },
  redirect: '/mall',
  children: [
    {
      path: '/mall',
      name: 'mall',
      component: RouteView,
      redirect: '/mall/goods',
      meta: { title: '积分商城', icon: 'table' },
      children: [
        {
          path: '/mall/goods',
          name: 'goods',
          component: RouteView,
          hideChildrenInMenu: true,
          meta: { title: '商品管理', keepAlive: false },
          children: [
            {
              path: '/mall/goods/list',
              name: 'goodsList',
              component: () => import('@/views/goods/TableList'),
              meta: { title: '列表', keepAlive: false },
            },
            {
              path: '/mall/goods/create',
              name: 'goodsList',
              component: () => import('@/views/goods/create'),
              meta: { title: '增加', keepAlive: false },
            },
            {
              path: '/mall/goods/edit',
              name: 'goodsList',
              component: () => import('@/views/goods/edit'),
              meta: { title: '编辑', keepAlive: false },
            },
          ],
        },
        {
          path: '/mall/address',
          name: 'address',
          component: () => import('@/views/address'),
          meta: { title: '收货信息管理', keepAlive: false },
        },
      ],
    },
    {
      path: '/mall/order',
      name: 'order',
      component: () => import('@/views/order'),
      meta: { title: '订单记录', icon: 'table' },
    },
  ],
}];

/**
 * 基础路由
 * @type { *[] }
 */
export const BASIC_MAP = [
  {
    path: '/404',
    component: () => import(/* webpackChunkName: "fail" */ '@/components/Exception/404'),
  },
  {
    path: '/exception',
    redirect: '/exception/403',
    component: BasicLayout,
    children: [
      {
        path: '403',
        name: '403',
        component: () => import('@/components/Exception/403'),
      },
    ],
  },
];
